module.exports = __webpack_public_path__ + "static/media/skeleton_wizard_circle.f55252f4.png";